import { AdCampaignResultWithContentDetail } from 'api';
import { EpisodeInputValue } from '../CampaignCreationView/EpisodeStep/PodcastEpisodeInput';

export const getCampaignEpisode = (
  campaign: AdCampaignResultWithContentDetail,
): EpisodeInputValue => {
  if (campaign.contentType === 'youtubeVideo') {
    const { youtubeVideoUrl, videoId, title } = campaign.contentDetail;

    return { type: 'youtubeVideo', url: youtubeVideoUrl, videoId, title };
  }

  const {
    contentDetail: { podcastThumbnailUrl, podcastTitle, episodeTitle },
    podcastId = '',
    remoteEpisodeId = '',
  } = campaign;

  return {
    type: 'podcastEpisode',
    episodeId: remoteEpisodeId,
    podcast: {
      podcastId,
      imageUrl: podcastThumbnailUrl,
      thumbnailUrl: podcastThumbnailUrl,
      title: podcastTitle,
    },
    thumbnailUrl: podcastThumbnailUrl,
    title: episodeTitle,
  };
};

export const getContentTarget = (episode: EpisodeInputValue) => {
  if (episode.type === 'youtubeVideo') {
    return { youtubeVideoUrl: episode.url };
  }

  return {
    podcastId: episode.podcast.podcastId,
    remoteEpisodeId: episode.episodeId,
  };
};
